/**
 * TS port of MonikerKey.Normalize (lib/src/Services/MonikerKey.cs) — trim, strip underscores,
 * lowercase. CanonicalMonikerScanner.Scan recomputes this itself for scalar placeholders (so a
 * placeholder's normalizedKey sent by the editor is never trusted), but it takes LoopBlock's and
 * ConditionalBlock's NormalizedKey as-sent — so the editor must compute it correctly for those two
 * node types, or a clash-detection pass server-side would compare against the wrong key.
 */
export function normalizeMonikerKey(rawName: string): string {
  return rawName.trim().replace(/_/g, '').toLowerCase()
}
